import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type AssetRestorationTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type RestoreAssetTaskInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<AssetRestorationTask>, 'assets'>;
  onCancel: () => void;
};

export const RestoreAssetTaskInProgressPanelItem = memo(
  ({ onCancel, metadata: { assets } }: RestoreAssetTaskInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? 'Recovering…' : 'Recovering'}</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            {assets.length === 1 ? (
              <>
                <span className="flex-none pr-1">Recovering asset: </span>
                <EllipsisInMiddle className="font-bold" text={assets[0].title || ''} />
              </>
            ) : (
              <span className="truncate">Recovering {assets.length} assets</span>
            )}
          </FileStatusSubtitle>
        }
        buttons={<TaskPaneCancelOrHideButton onClick={onCancel} />}
      />
    );
  },
);

RestoreAssetTaskInProgressPanelItem.displayName = 'RestoreAssetTaskInProgressPanelItem';
